export default "__VITE_ASSET__CS73aZ18__"